import React from "react"
import { LEGACY_DOMAIN } from "constants/index";
import Image from 'react-bootstrap/Image';

function getTeamLink(teamName, teamId) {
    return <a href={LEGACY_DOMAIN + "/teams?v=teams&t=" + teamId} target="_blank">{teamName}</a>
};

function getLiveScoreLink(matchId){
    return <a href={LEGACY_DOMAIN + "/livematch?id=" + matchId}>Live Score</a>
}

function getPlayerImage(imageLocation){
   return <Image className='border' src={LEGACY_DOMAIN + "/upload/userimages/" + imageLocation} width={100} height={100} roundedCircle responsive />
}

export {
    getTeamLink,
    getLiveScoreLink,
    getPlayerImage
};